<div class="sync-fusion-main-container">
    <div class="preview-sop-search-container">
        <div class="search-container">
            <input matInput [(ngModel)]="searchText" placeholder="Search by name/part number" />
            <mat-icon matSuffix (click)="searchText ? clearSearch() : onSearchInputChange()">{{searchText ? 'close' :
                'search' }}</mat-icon>
            <div class="search-btn-container" *ngIf="searchText" (click)="onSearchInputChange()">
                <mat-icon style="cursor: pointer;">search</mat-icon>
                <span>Search</span>
            </div>
        </div>
        <div class="form-fields-container" *ngIf="selectedSOP">
            <div class="details-input-field">
                <span><strong> Part Number : </strong></span>
                <span>{{selectedSOP.partNo}}</span>
            </div>
            <div class="details-input-field">
                <span><strong>Station : </strong></span>
                <span>{{selectedSOP.station}}</span>
            </div>
        </div>
    </div>
    <div class="not-found-container" *ngIf="hasSearched && selectedSOP === null">
        <span><strong>No SOP found</strong></span>
    </div>
    <div class="preview-sop-content-container" *ngIf="selectedSOP">
        <div class="video-instructions-container">
            <div class="video-image-placeholder-container">
                <div class="video-field-container">
                    <span>Video</span>
                    <div *ngIf="formData?.videoProcessing === 'COMPLETED'; else showConditionalContent"
                        class="video-container">
                        <video #target class="video-js vjs-default-skin" controls preload="auto" width="100%"
                            height="100%" style="object-fit: contain; width: 100%; height: 100%;">
                        </video>
                    </div>
                    <ng-template #showConditionalContent>
                        <div *ngIf="formData?.videoProcessing === 'IN-PROGRESS'; else checkIfFailed"
                            class="video-container">
                            <mat-spinner diameter="40"></mat-spinner>
                            <span class="ms-2">{{'Processing video...'}}</span>
                        </div>
                    </ng-template>
                    <ng-template #checkIfFailed>
                        <div *ngIf="formData?.videoProcessing === 'FAILED';" class="video-container">
                            <span class="text-danger">⚠️ Video processing failed.</span>
                        </div>
                    </ng-template>
                </div>
                <div class="image-container">
                    <span class="pl-2"><strong>Sketch,Photo,Diagram</strong></span>
                    <div class="image-grid">
                        <!-- <img [src]="selectedStepImage" alt="Step Image" class="preview-image"
                            [ngClass]="{'first-image': selectedStepImage?.includes('assets/img/assembly_symbols.png')}" /> -->
                        <ng-container *ngIf="!fetchingImage[currentPlayingIndex]; else loading">
                            <img *ngIf="selectedStepImage; else placeholder" [src]="selectedStepImage" alt="Step Image"
                                class="preview-image" />
                        </ng-container>
                        <ng-template #loading>
                            <div class="loader-container">
                                <svg class="hourglass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 206"
                                    preserveAspectRatio="none">
                                    <path class="middle"
                                        d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z" />
                                    <path class="outer"
                                        d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z" />
                                </svg>
                                <span> Fetching Image...</span>
                            </div>
                        </ng-template>
                        <ng-template #placeholder>
                            <div class="loader-container">
                                <mat-icon style="font-size: 40px; width: auto;height: auto;">image_not_supported</mat-icon>
                                <span>No Image available</span>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div class="custom-rich-editor-cont">
                <div id="custom-toolbar">
                </div>
                <div class="toggle-container-wrapper">
                    <span>Instructions</span>
                    <div class="toggle-container">
                        <div class="toggle-button" [ngClass]="{'active': !languageControl.value}"
                            (click)="changeLanguage(false)">
                            English
                        </div>
                        <div class="toggle-button" [ngClass]="{'active': languageControl.value}"
                            (click)="changeLanguage(true)">
                            Tamil
                        </div>
                    </div>
                </div>
                <quill-editor #quillEditor [modules]="editorModules" [(ngModel)]="selectedInstructions"
                    [readOnly]="true" placeholder="Type your Instructions" style="height: 100%;">
                </quill-editor>
            </div>
        </div>
        <div class="steps-main-container" *ngIf="sopSteps?.length > 0 && sopStepForm?.get('steps')"
            [formGroup]="sopStepForm">
            <span>Steps</span>
            <div class="steps-scrollable-container" formArrayName="steps">
                <div class="step-card-container" *ngFor="let step of steps.controls; let i = index" [formGroupName]="i">
                    <div class="header">
                        <div class="input-field">
                            <input matInput formControlName="stepName" placeholder="Enter Sequence Name" readonly
                                [ngClass]="{ 'input-error': step.get('stepName')?.hasError('required') && step.get('stepName')?.touched,
                                'playing-border': currentPlayingIndex === i }">
                            <span class="error-msg"
                                *ngIf="step.get('stepName')?.hasError('required') && step.get('stepName')?.touched">
                                Work Sequence is required.</span>
                        </div>
                        <mat-icon matTooltip="Play step" color="primary" class="play-icon"
                            [class.disabled]="currentPlayingIndex === i"
                            (click)="playStep(step,i)">play_circle_filled</mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>